import * as React from 'react';

import { faAngleDown } from '@fortawesome/pro-light-svg-icons';

import { Button, Menu, MenuItem } from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';

interface MenuButtonProps {
  label: string;
  options: { label: string; onClick: () => void }[];
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
}

export default function MenuButton({
  label,
  options,
  size,
  disabled
}: MenuButtonProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="menu-button"
        color="dark"
        disabled={disabled}
        variant="contained"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<FontAwesomeSvgIcon icon={faAngleDown} />}
        size={size}
      >
        {label}
      </Button>
      <Menu
        id="menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'menu-button'
        }}
      >
        {options.map((option) => {
          return (
            <MenuItem
              key={option.label}
              onClick={() => {
                option.onClick();
                handleClose();
              }}
            >
              {option.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
